import styles from './style.module.scss';

const noDataImg = require('../../assets/images/nodata.svg').default;

interface Props {
    description?: string;
};

function NoData(props: Props) {
    const { description } = props;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <img src={noDataImg} alt="" />
                <span className={styles.content_title}>No data</span>
                <span className={styles.content_description}>{description}</span>
            </div>
        </div>
    );
};

export default NoData;
